import * as React from "react";

const SvgComponent = (props) => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2 4H0v14c0 1.1.9 2 2 2h14v-2H2V4Zm16-4H6C4.9 0 4 .9 4 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2Zm0 14H6V2h12v12ZM10 3.5v9L16 8l-6-4.5Z"
      fill="#4F4F4F"
    />
  </svg>
);

export default SvgComponent;
